import { Dropdown } from 'ccs-ui-components';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AUTH_TYPE, SERVICE_TYPE_KEY_VALUE } from '../../../../../../constants';
import classes from './AuthType.module.scss';

interface IAuthTypeProps {
  authTypeChangeHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  serviceTypeValue: string | undefined;
  authTypeValue: string | undefined;
}
const AuthType = ({
  authTypeChangeHandler,
  serviceTypeValue,
  authTypeValue
}: IAuthTypeProps) => {
  const { t: translate } = useTranslation();
  return (
    <Row>
      <Col md={6}>
        <Form.Group controlId="authType">
          <Dropdown
            isMandatory
            labelText={String(translate('service_details_form_component.lbl_auth_key_type'))}
            label=""
            data={
              serviceTypeValue === SERVICE_TYPE_KEY_VALUE.REST
                ? AUTH_TYPE
                : [AUTH_TYPE[0]]
            }
            value={authTypeValue}
            className={classes['auth-type-dropdown']}
            name="authType"
            onChange={authTypeChangeHandler}
            data-testid="auth-type-dropdown"
            placeholder={
              String(translate('fsm_registry_form.lbl_placeholder_select'))
            }
            id="authType"
          />
        </Form.Group>
      </Col>
    </Row>
  );
};

export default AuthType;
